import { externalImagePaths as a } from "../../_vars/ahd-fleet/external-image-paths.mjs";
function n(e) {
  return Array.from(new Set(e));
}
function u(e) {
  var r;
  return (r = n([...a, "/static/media/placeholder"])) == null ? void 0 : r.some((t) => e == null ? void 0 : e.includes(t));
}
export {
  u as default
};
